const rfpStatuses = Object.freeze({
  RFP_PENDING: 'RFP_PENDING',
  RFP_SENT: 'RFP_SENT',
  RFP_COMPLETED: 'RFP_COMPLETED',
});

export default rfpStatuses;
